module.exports = __webpack_public_path__ + "static/media/subICloud3.0e6fa0ec.png";